import { useTranslation } from "react-i18next";

/**
 * A11y-konformer Fallback fuer die Route-Lazy-Suspense-Boundaries (TES-1653).
 * Mirror der Loading-Konvention (role="status" + aria-live + uebersetztes Label + sr-only Text,
 * vgl. SyncOverlay), damit Screenreader das Nachladen eines Route-Chunks angekuendigt bekommen.
 */
export function RouteSuspenseFallback() {
  const { t } = useTranslation();
  const label = t("common.loading");
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      className="flex min-h-[60vh] w-full items-center justify-center"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-primary" />
      <span className="sr-only">{label}</span>
    </div>
  );
}
